// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const OAuthConfiguration = {
    clientCredentials: (value) => {
        return Object.assign(Object.assign({}, value), { type: "clientCredentials", _visit: function (visitor) {
                return FernIr.OAuthConfiguration._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "clientCredentials":
                return visitor.clientCredentials(value);
            default:
                return visitor._other(value);
        }
    },
};
